export const apiConfig = (state) => {
    return state.apiConfig;
}